import lottie from "lottie-web"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

export function ScrollLottie(obj) {
  const anim = lottie.loadAnimation({
    container: document.querySelector(obj.target),
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: obj.path,
  })

  const timeObj = { currentFrame: 0 }
  const endString =
    obj.speed === "slow"
      ? "+=2000"
      : obj.speed === "medium"
      ? "+=1000"
      : obj.speed === undefined
      ? "+=1250"
      : "+=500"

  ScrollTrigger.create({
    trigger: obj.target,
    scrub: true,
    pin: false,
    start: window.innerWidth > 768 ? "top 50%" : "top 25%",
    end: endString,
    onUpdate: (self) => {
      if (obj.duration) {
        gsap.to(timeObj, {
          duration: obj.duration,
          currentFrame: Math.floor(self.progress * (anim.totalFrames - 1)),
          onUpdate: () => {
            anim.goToAndStop(timeObj.currentFrame, true)
          },
          ease: "expo",
        })
      } else {
        anim.goToAndStop(self.progress * (anim.totalFrames - 1), true)
      }
    },
  })
}
